// @ts-nocheck
export default {
  RECEIVING_TABLE_STATE_SET: 'RECEIVING/TABLE_STATE_SET',
  RECEIVING_TABLE_STATE_RESET: 'RECEIVING/TABLE_STATE_RESET',
};
